import { render, staticRenderFns } from "./LoadEnergyScene.vue?vue&type=template&id=4c745654&scoped=true"
import script from "./LoadEnergyScene.vue?vue&type=script&lang=js"
export * from "./LoadEnergyScene.vue?vue&type=script&lang=js"
import style0 from "./LoadEnergyScene.vue?vue&type=style&index=0&id=4c745654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c745654",
  null
  
)

export default component.exports